<template>
    <form class="auth-form" @submit.prevent="register" @keydown="form.onKeydown($event)">
        <div class="form-row">
            <div class="form-group col-md-12">
                <label>Business Name</label>
                <input
                    v-model="form.business_name" :class="{ 'is-invalid': form.errors.has('business_name') }"
                    type="text"
                    name="business_name" class="form-control" placeholder="(optional)"
                >
                <has-error :form="form" field="business_name"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-12" :class="{'col-lg-6':!fullWidth}">
                <label class="required">First Name</label>
                <input
                    v-model="form.first_name" :class="{ 'is-invalid': form.errors.has('first_name') }" type="text"
                    name="first_name" class="form-control"
                >
                <has-error :form="form" field="first_name"/>
            </div>
            <div class="form-group col-md-12" :class="{'col-lg-6':!fullWidth}">
                <label class="required">Last Name</label>
                <input
                    v-model="form.last_name" :class="{ 'is-invalid': form.errors.has('last_name') }" type="text"
                    name="last_name" class="form-control"
                >
                <has-error :form="form" field="last_name"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-12" :class="{'col-lg-6':!fullWidth}">
                <label class="required">Email</label>
                <input
                    v-model="form.email" :class="{ 'is-invalid': form.errors.has('email') }" type="email"
                    name="email"
                    class="form-control"
                >
                <has-error :form="form" field="email"/>
            </div>
            <div class="form-group col-md-12" :class="{'col-lg-6':!fullWidth}">
                <label class="required">Password</label>
                <input
                    v-model="form.password" :class="{ 'is-invalid': form.errors.has('password') }" type="password"
                    name="password" class="form-control"
                >
                <has-error :form="form" field="password"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-12">
                <label class="required">Industry</label>
                <b-form-select
                    v-model="form.industry_id"
                    :options="[{
                        text: '-- Select an industry --',
                        value: null,
                        selected: true,
                        disabled: true
                    }, ...industries]"
                    :class="{ 'is-invalid': form.errors.has('industry_id') }" name="industry_id"
                    class="form-control"
                />
                <has-error :form="form" field="industry_id"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-12" :class="{'col-lg-6':!fullWidth && form.hear_about === 'other'}">
                <label>How did you hear about us?</label>
                <b-form-select
                    v-model="form.hear_about" :options="hear_about"
                    :class="{ 'is-invalid': form.errors.has('hear_about') }" name="hear_about"
                    class="form-control"
                />
                <has-error :form="form" field="hear_about"/>
            </div>
            <div
                class="form-group col-md-12 d-none"
                :class="{'d-block':form.hear_about === 'other', 'col-lg-6':!fullWidth && form.hear_about === 'other'}"
            >
                <label>Please specify</label>
                <input
                    v-model="form.hear_about_other" :class="{ 'is-invalid': form.errors.has('hear_about_other') }"
                    type="text"
                    name="password" class="form-control"
                >
                <has-error :form="form" field="hear_about_other"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-12">
                <b-form-checkbox
                    id="newslettter"
                    v-model="form.newsletter"
                    class="form-check form-check-block"
                    :class="{ 'is-invalid': form.errors.has('newsletter') }"
                    name="newslettter"
                >
                    I am happy to receive occasional marketing communications
                </b-form-checkbox>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-12 mt-4" :class="{'col-lg-6':!fullWidth && !fullWidthSubmit}">
                <v-button :loading="loading">
                    Register Now
                </v-button>
            </div>
        </div>
    </form>
</template>
<script>
import Form from 'vform'

export default {
    name: 'RegisterForm',
    middleware: 'guest',
    props: {
        fullWidth: Boolean,
        fullWidthSubmit: Boolean,
        industries: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data: () => ({
        loading: false,
        hear_about: [
            {
                text: '-- Select an option --',
                value: null,
                selected: true,
                disabled: true
            },
            {
                text: 'Google search (or other search engine)',
                value: 'google'
            },
            {
                text: 'Instagram',
                value: 'instagram'
            },
            {
                text: 'LinkedIn',
                value: 'linkedin'
            },
            {
                text: 'Word of mouth',
                value: 'word'
            },
            {
                text: 'Other',
                value: 'other'
            }
        ],
        form: new Form({
            business_name: null,
            first_name: '',
            last_name: '',
            email: '',
            industry_id: null,
            password: '',
            newsletter: true,
            hear_about: null,
            hear_about_other: null
        })
    }),
    methods: {
        async register () {
            this.loading = true
            let data

            // Register the user.
            try {
                const response = await this.form.post('/register')
                data = response.data
            } catch (e) {
                this.loading = false
                return
            }

            // Log in the user.
            const { data: { token } } = await this.form.post('/login')

            // Save the token.
            await this.$store.dispatch('auth/saveToken', { token })

            // Fetch the user.
            await this.$store.dispatch('auth/fetchUser')

            this.$toast.success(`Hi ${data.first_name}. Your account was created.`)

            this.$emit('registration-success')
            this.loading = false
        }
    }
}
</script>
